import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const formatHHmm = (value, tz = 'America/New_York') =>
    value && !isNaN(value) ? formatInTimeZone(value, tz, 'HHmm') : '';

// explicit overrides that map to a fixed value.
const SITE_CODE_OVERRIDES = { '24P': '1241' };
export const formatLocationCode = (site) => (site ? SITE_CODE_OVERRIDES[site.toUpperCase()] || `1${site}` : '');

// Location code for a GE Delivers export row: GE dispatch site, "1"-prefixed.
export const getLocationCode = (row) => formatLocationCode(row?.orders?.[0]?.service_catalog_filter?.site);

// GE Delivers upload filename: {LocationCode}{YYYYMMDDHHmmss}
export const buildGEDeliversFilename = (data, now) =>
    `${getLocationCode(data?.[0])}${format(now, 'yyyyMMddHHmmss')}.csv`;

// GE Delivers route export. Fixed positional format, emitted without a header row
// (see generateCSV's noHeaders option). Headers below are for readability/tests only.
export const ROUTE_GE_DELIVERS_COLUMNS = [
    {
        // 1. Warehouse location code (GE dispatch site, e.g. "3QM"), "1"-prefixed
        header: 'location_code',
        getValue: getLocationCode,
    },
    {
        // 2. Order PO number (GE delivery_id lands on po_number at ingest)
        header: 'po_number',
        getValue: ({ orders }) => orders?.[0]?.po_number || '',
    },
    {
        // 3. Always blank
        header: 'blank_3',
        getValue: () => '',
    },
    {
        // 4. Truck
        header: 'truck',
        getValue: ({ route }) => route.resource?.name || '',
    },
    {
        // 5. Stop sequence (running per-order number, same as Salesforce)
        header: 'stop',
        getValue: ({ opt }) => opt?.stopSequence,
    },
    {
        // 6. Window start, HHMM
        header: 'window_start',
        getValue: ({ opt }) => opt?.scheduledStart,
        format: (value, { tz = 'America/New_York' }) => formatHHmm(value, tz),
    },
    {
        // 7. Window end, HHMM
        header: 'window_end',
        getValue: ({ opt }) => opt?.scheduledEnd,
        format: (value, { tz = 'America/New_York' }) => formatHHmm(value, tz),
    },
    {
        // 8. Always blank
        header: 'blank_8',
        getValue: () => '',
    },
    {
        // 9. Constant source marker on every row
        header: 'source',
        getValue: () => 'UPLOADBYRLX',
    },
];
